module.exports = __webpack_public_path__ + "static/media/aboutBg.e21143a3.png";